import React, {Suspense} from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {BrowserRouter, Route, Routes} from "react-router-dom";
import {Provider} from "react-redux";
import store from "./store/store";
import './index.css';
import 'bootstrap/dist/css/bootstrap.min.css'
import 'react-toastify/dist/ReactToastify.css';
import SignIn from "./pages/loginPage";
import Invoices from "./pages/invoices";
import SerialNumber from "./pages/serialNumber";
import NotFound from "./pages/notfound";
import IconStepper from "./pages/checkTrackCode";
import IconStepperUz from "./pages/checkTrackCodeUz";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <BrowserRouter>
        <Suspense fallback={'Loading...'}>
            <Provider store={store}>
                <Routes>
                    <Route path={'/'} element={<IconStepper/>}/>
                    <Route path={'/uz'} element={<IconStepperUz/>}/>
                    <Route path={'/ru'} element={<IconStepper/>}/>
                    <Route path={"*"} element={<NotFound/>} />
                </Routes>
            </Provider>
        </Suspense>
    </BrowserRouter>
);

reportWebVitals();
